<template>
    <div id="personal_intru">
        <div class="close-btn">
            <button @click="close"><v-img src="@/assets/img/closeButton2.svg"></v-img></button>
        </div>
        <div class="content-wrap">
            <div class="title"><p>고래의 아이</p></div>
            <div class="content">
                2월과 3월은 원래 춥다. 미리 알고 있었으면서도 입학식은 여전히 추웠다. 냉동 창고 같은 세상을 걸어 반을 찾아가던 날에, 각 반의 TV 모니터에서는 방송실에서 틀어놓은 입학식 대기화면과 함께 리스트의 피아노곡이 나오고 있었다. 사랑의 꿈. 겨울에 빳빳하게 굳은 몸으로 그 곡을 듣자면 언제나 입학식의 공기가 생각난다. 곡의 선율은 음울하지 않다. 지나치게 낙관적이거나 명랑하지도 않다. 그러나 흐름 끝에 벅차오르는 클라이맥스가 있었다. 끝이 있는 것들만이 최고조의 순간을 가진다. 
<br>
<br>
입학식부터 무료한 얼굴로 곤죽이 되어 앉아 있는 아이는 드물다. 무언가를 시작하는 날씨와 상징적인 긴장감이 맞물리면, 그날 하루만큼은 집에서 출발한 기분 그대로 꽁꽁 언 채 사람들과 만난다. 이때의 기억으로 나는 추운 것을 더운 것보다 청결하게 여긴다. 추위는 세포가 죽은 생물이 부패하는 것을 멎게 한다. 졸업과 입학은 언제나 추운 시기에 이루어진다. 한 시절을 겪으며 문드러진 몸을 추위 속에 얼려서 다음 단계로 전달하듯이. 
<br>
<br>
우리가 입학하던 해의 입시 정답은 <span class="sound_text_visited" :class="{ 'sound-text' : visited[2] === 'disabled'}" @click="play('희망')">‘도망가는 희망을 손바닥에 가두다’</span>였다. 어떤 사람들에게는 <span class="sound_text_visited" :class="{'sound-text' : visited[3] === 'disabled'}"  @click="play('메아리')">‘과녁 한가운데를 뚫는 메아리’</span>, 그리고 단 한명에게는 ‘하늘의 고래와 눈을 마주치다’였다. 
<br>
<br>
“쟤가 고래야.”
<br>
<br>
우리 학교 고래는, 옆에 앉은 친구가 그의 얼굴을 모른다고 하거든 함께 복도로 나가 짚어주기까지 해야 하는 존재였다. 고래는 정수기에서 뜨거운 찻물을 받고 있었다. 머리카락이 뺨으로 살짝 쏟아져서 얼굴이 가려졌다. 저기 봐. 쟤야. 친구가 내 귀에다가 속삭였다. 나는 일부러 대답하지 않았다. 그러자 고래투어 가이드 역할을 자청하고 있는 미사가 팔뚝을 쥐며 재촉했다. 봤어?
<br>
<br>
“그래. 쉿.”
<br>
<br>
소리 죽여 답했다. 나는 미사가 제발 말을 참았다가 교실에서 해주기를 바랐다. 그렇게 멀지 않은 거리에 있는 고래가 눈치챌까봐 신경이 쓰였다. 유일하게 최상급의 문장을 들을 수 있었던 애인데. 미사는 상황의 특수성을 고려하지 않고 하고 싶은 말 먼저 하는 경향이 있다. 고래가 남색 스타벅스 텀블러 뚜껑을 닫았다. 그리고 고개를 들었다. 
<br>
<br>
그 애를 보는 게 아니었던 것처럼 복도 끝으로 시점을 흐렸다. 그러자 걔도 자기 뒤편을 돌아봤다. 별다른 게 없다는 걸 확인하고는 다시 우리 쪽을 봤다. 찰나에 시선이 맞았다. 차가운 복도의 고래와 눈을 마주쳤다. 그의 명찰에 ‘김이리에’라는 이름이 쓰여 있었다. 
<br>
<br>
이름 죽이네. 고래를 처음 구경한 감상은 이름에 관한 속성으로 남았다. 희귀한 이름을 속으로 한 번 발음했다. 김이리에. 이름이 부러워서 수석 입학에 대한 미약한 질투마저 희석될 것 같았다. 
<br>
<br>
<br>
<br>
국립 음향 영재원은 입학시험 절차가 아주 간단하다. 물론 그 형용은 단지 시험 방식에 관한 것이다. 이 학교 지망생들은 아무도 재수를 생각하지 않는다. 단 한 번의 시험만으로도 적합한 인간과 그렇지 않은 인간을 가를 수 있었다. 
<br>
<br>
시험이 시작되고 끝나기까지는 딱 10분이 걸린다. 30명 단위의 교실로 배정된 수험생들은 각자 칸막이로 나누어진 책상에 앉는다. 규격이 정해진 종이와 필기구를 받는다. 시험지에는 이름과 생년월일, 수험번호를 쓰는 자리가 있다. 그 밑으로는 한 문장 정도를 쓸 수 있는 칸이 세 개 마련되어 있다. 수험생들이 인적사항 입력을 마치거든 스피커에서 그들에게 말을 걸어온다. 
<br>
<br>
방울 소리가 들린 뒤에 들리는 문장들을 모두 적으세요. 들리는 문장의 겹을 모두 적으세요. 제시문장은 총 세 번 반복됩니다. 그럼 시작합니다.
<br>
<br>
(지상에 툭 떨어진 별이 딱딱한 곳에 부딪히는 소리가 난다)
<br>
<br>
과녁 한가운데를 뚫는 메아리<br>
도망가는 희망을 손바닥에 가두다<br>
하늘의 고래와 눈을 마주치다<br>
<br>
<br>
문장들은 동시에 재생된다. 순서대로 하나씩 들려주는 것이 아니다. 세 사람이 일순간 다른 말을 하는 것처럼 겹쳐서 재생된다. 이 세 가지 문장은 모두 다른 주파수의 영역에 존재한다. 1단계의 문장마저 기본적인 가청 주파수를 벗어나있다. 이 학교는 평균의 범위로부터 위아래로 자꾸 벗어나는 음향 영재를 찾으려는 거니까. 
<br>
<br>
어떤 사람은 한 문장을 듣고, 그보다 뛰어나면 두 문장을 듣고, 김이리에 같은 인간은 세 문장을 듣는다. 물론 아무소리를 듣지 못하는 사람도 있다. 그들은 방울소리가 끝난 뒤 잠시 멈춰있다. 주변에서 고개 숙여 무언가를 적는 걸 인식하고 당혹스러운 표정을 짓는다. 울 것 같은 얼굴로 손을 든다. 음향 사고에 대해 묻고자 하는 것이다. 감독관은 익숙하게 답변이 적힌 카드를 들어올린다. 필요한 경우 가까이 다가가 점자판을 더듬어보게 해준다. 
<br>
<br>
[음향 사고는 일어나지 않았습니다. 모든 문장이 약속한 대로 재생되었습니다.]
<br>
<br>
한 묶음의 문장이 세 번 반복되는 약 20초의 시간, 그걸 정적으로 인식하는 이들에게는 세상에서 완전히 유리되는 공백의 순간이다. 문을 열었으나 그 너머에 ‘비어있음’ 그 자체만이 있을 때의 당혹감, 절망, 문을 닫고 돌아설 때의 망연함. 인생에 딱 한번 뿐인 테스트였다. 
<br>
<br>
음향원의 학생 선발 방식은 사람들에게 스피드 복권 같은 흥미를 끌었다. 오래 기다리거나 인내로 연마하지 않아도 순식간에 판별 받는 재능이다. 세상에 이런 것은 드물다. 인터넷에서 종종 
<br>
<br>
제목 : 한국인 빨리빨리 민족인 이유<br>
내용 : 국가기관 입학시험도 개빨리 끝냄<br>
<br>
<br>
이와 같은 설명과 함께 첨부되는 뉴스 클립들로 놀림거리가 되지만 말이다. 나는 여전히 음향원이 자비는 없지만 악질적이지는 않다고 생각한다. 조금만 더 하면 될 것 같아요. 학생의 개성이 어딘가에 부적합하다는 뜻은 아닙니다. 그러나 우리가 찾는 인재와는 다른 것 같아요. 라는 종류의 말로 기만하지는 않는다. 
<br>
<br>
<br>
<br>
제 1회 시험 이후의 논란보다는 덜하지만, 여전히 음향원의 선발 방식은 사람들의 환상을 자극했다. 
<br>
<br>
“기분이 어때요. 특별한 사람이 되었다는 실감이 나나요?”
<br>
<br>
그런 의미가 담긴 물음을 받고는 한다. 입학 직전에도, 재학 중에도, 졸업한 뒤에도. 정말로 궁금했다기보다는 의도 없는 스몰 톡처럼 여겨지기는 했다. 그래도 산뜻한 농담으로 응대하는 방법은 아직까지 모르겠다. 특별한 사람을 뽑는 듯한 인상을 주는 곳에는, 언제나 더 특별한 아이와 덜 특별한 아이가 존재한다. 실감과 확신에는 종착지가 없다.
<br>
<br>
음향 영재원에 입학한 것은 나를 행복하게 만들지는 않았다. 단지 안심하게 만들었다. 청력은 나이가 들면 퇴화한다. 하지만 절망하지 않을 자신이 있었다. x축과 y축이 한 점에서 만나듯이, 나의 이 순간만이 음향원에 담길 수 있는 찰나였다는 것에 만족한다. 
<br>
<br>
그러니까, 나는 y라는 음향능력 자체에 천착하지 않는다. 그것으로 내가 완성되었다고 믿을 수 없다. 내 삶의 시기마다 좌표를 만들어줄 어떤 것이 필요할 뿐이다. 그래서 나는 음향원이 끔찍하게 좋았다. 끔찍하게.
<br>
<br>
정정한다. 끔찍하고, 좋았다. 나만 일방적으로 이 자리를 구걸한 게 아니다. 음향원도 나를 필요로 했다. 내가 그들의 요구에 적합했다. 물살에 떠내려가다가 간신히 체의 철망을 쥔 것처럼 감사했다. 쌀알은 함께 체에 걸린 다른 알곡들을 시기하지 않아도 된다. 나는 김이리에를 미워하지 않아도 됐다. 그 마음이 나에게는 구원이었다. 
<br>
<br>
입학식 날의 나는 사랑의 꿈을 들으며 자리에 앉았다. 교실의 책걸상이 남거나 부족하지 않다는 것, 선생님이 부른 출석부에 내 이름이 있다는 것까지 확인하고 나서야 마음이 놓였다. 초대받지 않은 곳을 서성거리지 않아도 괜찮다. 나의 거취를 정하려고 어른들끼리 곤란한 목소리로 상의할 필요가 없다. 음향원에 좌표가 생겼다. 
<br>
<br>
            </div>
        </div>
    </div>
</template>
<script>
import eventBus from '@/plugins/eventbus.js'
import store from "@/store/index.js";


export default {
  name: 'index_two',
  data() {
        return {
            visited : {
                2: store.getters['getMusicIconUsable'](2),
                3: store.getters['getMusicIconUsable'](3), 
            },
            
        }
 },
  methods: {
    close() {
        this.$emit("btnclose");
    },
    play(message) {

        switch(message) {
            case '희망' :      
                this.visited[2] = 'active';
                store.commit("toggleText", 2);
                eventBus.$emit("iconUsable", 2); 
                
                break; 
            case "메아리" :
                this.visited[3] = 'active';
                store.commit("toggleText", 3)
                eventBus.$emit("iconUsable", 3); 
                
                break;
        }
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
display: none;
}

#personal_intru {
  box-sizing: border-box;

  position: absolute;
  height: 649px;
  width: 500px;

  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.6);

  background: rgba(26, 26, 26, 0.9);
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(40px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 20px;

  left: 656px;
  top: 350px;

  text-align: center;
}

.close-btn {
    position: relative;
    height: 16px;
    width: 16px;
    left: 16px;
    top: 16px;
    border-radius: 16px;
}

.content-wrap {
    position : relative;

    left: 60px;
    top: 64px;
    height: 569px;
    width: 380px;

    overflow-y: scroll;
}

.title {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height */

    text-align: center;

    color: #F1F1F1;

}

.content {
    margin-top: 58px;

    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 200%;
    /* or 36px */

    text-align: justify ;
    color: #F1F1F1;

}
@media (max-width: 600px) {

    #personal_intru {
        top: 500px;
        left: 0;
        width: 100vw;
        height: 600px;
        
    }

    .content-wrap {
        left: 45px;
        width: 310px;
        height: 510px;
    }
    
    .title {
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        color: #EAEAEA;


    }

    .content {
        width: 310px;
        height: 510px;
        font-weight: 600;
        font-size: 14px;
        line-height: 200%;
        color: #EAEAEA;

    }
}

</style>